<template>
  <div>
    <!--Stats cards-->
    <!-- div class="row">
      <div class="col-lg-2 col-md-4 col-sm-4" v-for="stats in statsCards" @click="gotoAbfrage">
        <link-card :type="stats.type"
                    :icon="stats.icon"
                    :small-title="stats.title"
                    :title="stats.value">
          <div class="stats" slot="footer">
            {{stats.title}}
          </div>
        </link-card>
      </div>
    </!-->

    <team v-if="checkPackage()"/>

    <news v-if="checkPackage()" />

  </div>
</template>
<script>
  import TaskList from './Widgets/TaskList'
  import swal from 'sweetalert2'
  import BasicChart from 'src/components/Dashboard/Components/BasicChart'
  import Team from 'src/components/Views/0.Startpage/Team'
  import News from 'src/components/Views/0.Startpage/News'

  export default {
    components: {
      TaskList,
      BasicChart,
      News,
      Team
    },
    mounted() {
      if (!this.checkPackage()) {
        return this.$router.push({ name: 'TeamContainer' })
      }
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    methods: {
      checkPackage() {
        return this.$auth.user.customer.settings.contract.packageType === 'premium'
      },
      showSwal () {
        swal({
            title: 'Deine wöchentliche Reflektion',
            html: '<div class="form-group">' +
            '<input id="input-field" type="text" class="form-control" />' +
            '</div>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          }).then(function (result) {
            swal({
              type: 'success',
              html: 'You entered',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false

            })
          }).catch(swal.noop)
      },
      gotoAbfrage() {
        this.$router.push('/admin/abfrage')
      }
    },

    data () {
      return {
        statsCards: [
          {
            type: 'warning',
            icon: 'fa fa-street-view',
            title: 'Meine Reflektion',
          },
          {
            type: 'success',
            icon: 'fa fa-users',
            title: 'Mein Team',
          },
          {
            type: 'danger',
            icon: 'fa fa-address-card',
            title: 'Teammitglieder',
          },
          {
            type: 'info',
            icon: 'fa fa-globe',
            title: 'Mein Unternehmen',
          },
          {
            type: 'warning',
            icon: 'fa fa-globe',
            title: 'Sonderprojekte',
          },
          {
            type: 'success',
            icon: 'fa fa-compass',
            title: 'Archiv',
          }
        ],
        activityChart: {
          data: {
            labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            datasets: [
              {
                label: "Data",
                borderColor: '#fcc468',
                fill: true,
                backgroundColor: '#fcc468',
                hoverBorderColor: '#fcc468',
                borderWidth: 8,
                data: [100, 120, 80, 100, 90, 130, 110, 100, 80, 110, 130, 140, 130, 120, 130, 80, 100, 90, 120, 130],
              },
              {
                label: "Data",
                borderColor: '#4cbdd7',
                fill: true,
                backgroundColor: '#4cbdd7',
                hoverBorderColor: '#4cbdd7',
                borderWidth: 8,
                data: [80, 140, 50, 120, 50, 150, 60, 130, 50, 130, 150, 100, 110, 80, 140, 50, 140, 50, 110, 150],
              }
            ]
          }
        }

      }
    }
  }

</script>
